import { csvCell } from '~/utils/csvCell';

type Row = Record<string, unknown>;
export const number = (v: unknown): number | null => {
  if (v === null || v === undefined || v === '') {
    return null;
  }
  const n = Number(typeof v === 'object' && 'value' in v ? v.value : v);
  return Number.isFinite(n) ? n : null;
};
export function csv(rows: Array<Row>, columns: Array<string>) {
  const cell = (v: unknown) => csvCell(v);
  return [columns.map(cell).join(','), ...rows.map((r) => columns.map((c) => cell(r[c])).join(','))].join('\r\n');
}
export function download(name: string, content: string) {
  const url = URL.createObjectURL(new Blob([content], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
